import i18n from 'i18n'

export class DiscountError extends Error {
	message: string
	title: string

	constructor(title: string, message: string) {
		super(message)
		this.title = title
		this.message = message
	}

	static notFound(): DiscountError {
		return new DiscountError(
			i18n.gettext('Promo code'),
			i18n.gettext('Invalid promo code')
		)
	}
}
